var _style, _path, _path2, _defs, _path3, _circle, _circle2, _circle3, _circle4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDermatology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st2{clip-path:url(#SVGID_00000001664564100269602510000013177021363346343812_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.5,99.1c0-28.7,4.2-24.4,6.3-32c1.3-4.9,2.5-14.5,3.2-20.7c0.3-3.1,2.9-5.5,6.1-5.6 c2.9-0.1,6.3-0.3,8.7-1.2c2-0.7,3.9-6.4,4.8-9.5c0.3-1.1-0.3-2.3-1.4-2.7l-8.7-2.6c-1.5-0.4-2.8-1.3-3.6-2.6 c-1.9-2.6-5.3-7.1-6.5-7.6c-0.9-0.3-1.6-1.1-1.8-2.1c-0.6-2.8-1.7-10-4.4-10c-2.8,0-4.5,8.5-5,11.9c-0.2,1.5-0.6,3-1.1,4.4 c-1.6,4.5-5,14.2-8.4,20.5C40.2,48,19.6,55.3,16.4,80.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.2,36.3c0,0,7,8.5,18.8,10.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 39.3,
    y: 51.5,
    transform: "matrix(0.9997 -2.608490e-02 2.608490e-02 0.9997 -1.8834 1.6281)",
    width: 44.3,
    height: 43
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181805129527422262930000014522019189988060545_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181805129527422262930000014522019189988060545_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6,90.9L72.3,80.4c2.9-3.6,4.3-8.2,3.8-12.8c-0.5-4.6-2.7-8.8-6.4-11.8c-3.6-3-8.2-4.5-13-4.4 c-4.7,0.3-9.2,2.2-12.5,5.6c-3.3,3.3-5,7.8-5.1,12.4c0,4.6,1.9,9,5.1,12.3s7.8,5.4,12.4,5.6c4.8,0.3,9.4-1.3,13-4.3l11.3,10.4 c0.4,0.4,0.8,0.5,1.3,0.5c0.5,0,1-0.2,1.2-0.5c0.4-0.4,0.6-0.8,0.6-1.3C84.1,91.6,83.9,91.2,83.6,90.9z M58.1,83.9 c-2.9,0.1-5.8-0.7-8.3-2.2c-2.5-1.5-4.4-3.7-5.7-6.3c-1.1-2.6-1.5-5.5-1.1-8.3c0.5-2.8,1.9-5.4,3.8-7.5c2-2,4.6-3.5,7.5-4.1 c2.8-0.7,5.8-0.4,8.5,0.6c2.7,1,5,2.8,6.8,5.2c1.7,2.3,2.6,5.1,2.7,7.9c0.1,3.8-1.3,7.5-4.1,10.3C65.7,82.1,62,83.8,58.1,83.9z "
  })))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.1,
    cy: 61.5,
    r: 1.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.1,
    cy: 68.9,
    r: 1.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.9,
    cy: 66.5,
    r: 1.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.9,
    cy: 74.4,
    r: 1.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDermatology);
export default __webpack_public_path__ + "static/media/Dermatology.b93e22942072d8a2e5f259b70ace3b3d.svg";
export { ForwardRef as ReactComponent };